<template>
    <!-- 02 : 专业建设解决方案 -->
    <div class="solution-edu-part-2 education-slide-in-up">
        <CommonComponentsUnionTitleWithNumber :union-title="data.partsInfo" />
        <div class="solution-edu-part-2-scroll-text">
            <CommonComponentsScrollText v-model="curIndex" :text-list="textList" :selector="'.solution-edu-part-2'" />
            <!-- <div class="solution-edu-part-2-scroll-change-content">{{ curIndex }}</div> -->
        </div>
        <div class="solution-edu-part-2-video">
            <CommonComponentsVideoPlayer
                :sources="[
                    {
                        src: data.media.mediaPath,
                        type: 'video/mp4',
                    },
                ]"
                :poster="data.media.poster"
            />
        </div>
    </div>
</template>

<script lang="ts" setup>
    import constructionVideo from '@assets/Video/solutions/academy/discipline.mp4';
    import constructionVideoPoster from '@assets/Video/solutions/academy/discipline.jpg';
    import { ref, reactive } from 'vue';
    import i18n from '@/locales';
    const { t } = i18n.global;

    const data = {
        partsInfo: {
            key: '02',
            title: 'global_solutions_edu_title_2',
        },
        media: {
            mediaPath: constructionVideo,
            poster: constructionVideoPoster,
        },
    };

    const curIndex = ref(1);

    const textList = reactive<string[]>([
        t('global_solutions_edu_part_2_text1'),
        t('global_solutions_edu_part_2_text2'),
        t('global_solutions_edu_part_2_text3'),
        t('global_solutions_edu_part_2_text4'),
        t('global_solutions_edu_part_2_text5'),
        t('global_solutions_edu_part_2_text6'),
    ]);
</script>

<style lang="less" scoped>
    .solution-edu-part-2 {
        display: flex;
        flex-direction: column;
        align-items: center;
        &-scroll-text {
            width: 100%;
            // height:;
        }
        // &-scroll-change-content {
        //     margin-top: 4vw;
        //     width: 100%;
        //     height: 35.4vw;
        //     background-color: antiquewhite;
        //     font-size: 5vw;
        //     display: flex;
        //     align-items: center;
        //     justify-content: center;
        // }

        &-video {
            margin-bottom: 100px;
            width: .convert(1200px) [ @vw];
            height: .convert(675px) [ @vw];
            video {
                width: 100%;
            }
        }

        @media (max-width: @screen-mobile-width) {
            padding-top: 60px;
        }
    }
</style>
